import { I18n } from '@calendly/i18n'
import { useMemo } from 'react'

const COUNTER_VALUE_LIMIT = 99
const COUNTER_TOOLTIP_LIMIT = 10
const AVATARS_LIMIT = 5
const UNFOLDED_AVATARS_COUNT = AVATARS_LIMIT - 1

const foldedProfilesCount = (profiles) => {
  if (profiles.length <= AVATARS_LIMIT) return 0

  return profiles.length - UNFOLDED_AVATARS_COUNT
}

const foldedProfilesText = (count) => {
  if (!count) return ''

  return (count > COUNTER_VALUE_LIMIT ? `${COUNTER_VALUE_LIMIT}+` : `+${count}`)
}

const foldedProfilesTooltip = (profiles) => {
  if (profiles.length <= AVATARS_LIMIT) return ''
  if (profiles.length <= COUNTER_TOOLTIP_LIMIT + UNFOLDED_AVATARS_COUNT) {
    return profiles.slice(UNFOLDED_AVATARS_COUNT).map(({ tooltip }) => tooltip).join(', ')
  }

  return I18n.t('publisher.event_types.card.counter_title', { count: foldedProfilesCount(profiles) })
}

const extractProfiles = (memberships) => (
  memberships.map((membership, index) => ({
    id: membership.id || index,
    letter: membership.avatar_letter || membership.avatarLetter,
    src: membership.avatar_url || membership.avatarUrl,
    tooltip: membership.name || membership.email,
    'aria-label': membership.name || membership.email
  }))
)

export const useDistinctEventTypeProfiles = ({ eventType, memberships, skip = false }) => {
  const etMemberships = memberships
    || eventType?.memberships
    || eventType?.event_type_memberships
    || eventType?.eventTypeMemberships

  return useMemo(() => {
    if (skip) return { profiles: [], avatarProfiles: [] }
    if (!etMemberships?.length) return { profiles: [], avatarProfiles: [] }

    const profiles = extractProfiles(etMemberships)

    const counterValue = foldedProfilesCount(profiles)
    const avatarProfilesCount = counterValue ? UNFOLDED_AVATARS_COUNT : AVATARS_LIMIT
    const avatarProfiles = profiles.slice(0, avatarProfilesCount)

    return {
      profiles,
      avatarProfiles,
      foldedProfilesText: foldedProfilesText(counterValue),
      foldedProfilesTooltip: foldedProfilesTooltip(profiles)
    }
  }, [
    skip,
    etMemberships
  ])
}
